import React from 'react'
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useSelector } from 'react-redux';

export default function SelectTemplateBottom({ offSet, PreviousDataShowing, nextButton, matchNextButton, NextDataShowing, layout_type }) {

  const userSetter = useSelector((state) => state.userSetter);
  const campaignSetter = useSelector((state) => state.campaignSetter);
  const templateSetter = useSelector((state) => state.templateSetter);
  return (
    <div className="cstm-table-footer">
      <ul className="ftr-btn-list">
        <li>
          {offSet == 0 ? (
            <button
              type="button"
              className="table-data-btn btn-prev disabled-btn"
              style={{
                cursor: "not-allowed",
                opacity: "0.6",
              }}
            >
              <ArrowBackIosIcon />
            </button>
          ) : (
            <button
              onClick={(e) => {
                if (userSetter.userFlow == 'createTemplate') {
                  PreviousDataShowing(e, templateSetter.templateType, layout_type);
                } else if (userSetter.userFlow == 'createCampaign') {
                  PreviousDataShowing(e, campaignSetter.campaignType, layout_type);
                }
              }}
              type="button"
              class="table-data-btn btn-prev"
            >
              <ArrowBackIosIcon />
            </button>
          )}
        </li>
        <li>
          {nextButton > matchNextButton ? (
            <button
              onClick={(e) => {
                if (userSetter.userFlow == 'createTemplate') {
                  NextDataShowing(e, templateSetter.templateType, layout_type);
                } else if (userSetter.userFlow == 'createCampaign') {
                  NextDataShowing(e, campaignSetter.campaignType, layout_type);
                }
              }}
              type="button"
              class="table-data-btn btn-next"
            >
              <ArrowBackIosIcon />
            </button>
          ) : (
            <button
              type="button"
              className="table-data-btn btn-next disabled-btn"
              style={{
                cursor: "not-allowed",
                opacity: "0.6",
              }}
            >
              <ArrowBackIosIcon />
            </button>
          )}
        </li>
      </ul>
    </div>
  )
}
